import { createSimpleLinkProps } from '../../external/components/link/LinkUtils'
import { isEmpty, isUndefined } from '../../external/utilities/GeneralUtils'
import {
  sendToExternalPath,
  sendToInternalPath,
} from '../../router/RouteManager'
import { translate } from '../Translation'

export const isData = function (data) {
  if (!isUndefined(data) && !isEmpty(data)) {
    return true
  }

  return false
}

// eslint-disable-next-line max-params
export const getTranslation = function (intl, token, defaulText, keyQualifier) {
  return translate(intl, token, null, null, [keyQualifier], defaulText)
}

export const getMarketingSpotFromContent = function (intl, content, infoData) {
  const spot = {}
  spot.title = getTranslation(
    intl,
    content.title.token,
    content.title.default,
    infoData.infoToken,
  )
  spot.author = ''
  spot.category = content.category
  spot.excerpt = getTranslation(
    intl,
    content.excerpt.token,
    content.excerpt.default,
    infoData.infoToken,
  )
  spot.image = infoData.baseImagesFolder + content.image
  spot.imageDescription = getTranslation(
    intl,
    content.imageDescription.token,
    content.imageDescription.default,
    infoData.infoToken,
  )
  spot.link = content.link
  spot.newWindow = content.newWindow
  spot.linkInternal = content.linkInternal

  return spot
}

export const getArticleFromContent = function (intl, content, infoData) {
  const article = {}
  article.title = getTranslation(
    intl,
    content.title.token,
    content.title.default,
    infoData.infoToken,
  )
  article.author = ''
  article.category = content.category
  article.categoryDisplayName = getTranslation(
    intl,
    content.tagline.token,
    content.tagline.default,
    infoData.infoToken,
  )
  article.excerpt = getTranslation(
    intl,
    content.excerpt.token,
    content.excerpt.default,
    infoData.infoToken,
  )
  article.image = infoData.baseImagesFolder + content.image
  article.link = content.link
  article.newWindow = content.newWindow
  article.linkInternal = content.linkInternal

  return article
}

export const getLinkObj = function (content) {
  return createSimpleLinkProps(
    content.link,
    content.linkInternal,
    content.newWindow,
  )
}

export const redirectToDestination = function (linkObj) {
  if (linkObj.linkInternal) {
    sendToInternalPath(linkObj.link)
  }

  sendToExternalPath(linkObj.link, linkObj.newWindow)
}

export const isShowCardBack = function (intl, spot, infoData) {
  return !isEmpty(
    getTranslation(intl, spot.token, spot.default, infoData.infoToken),
  )
}
